<template>
  <section class="container">
    <el-tabs v-model="activeTab">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab.label"
        :name="String(tab.name)"
      ></el-tab-pane>
    </el-tabs>
    <div class="flex-sb-center">
      <div class="flex">
        <template v-if="type!='subscribers'">
          <div class="flex-platform form-item mg-r-15">
            <span class="color-dark fw-600 fs-14 mg-r-15">Platform</span>
            <v-radio-group
              v-model="merchant_platform"
              button
              :list="serverTypeOption"
              @change="handleChange">
              <template v-slot:default="{item}">
                <span class="flex-align-center">
                  <span
                    v-if="item.id"
                    class="table-icon__img">
                    <img :src="getOptionName('serverTypeIcon',item.id)" >
                  </span>
                  <span>{{item.name}}</span>
                </span>
              </template>
            </v-radio-group>
          </div>
          <div class="form-item">
            <span class="color-dark fw-600 fs-14 mg-r-15">Marketing Communications</span>
            <v-radio-group
              v-model="marketing_comm"
              :list="onList"
              @change="handleChange"></v-radio-group>
          </div>
          <div class="form-item mg-l-15">
            <span class="color-dark fw-600 fs-14 mg-r-15">Type</span>
            <v-checkbox-group
              v-model="identity"
              :list="userTypeOptions"
              @change="handleChange"></v-checkbox-group>
          </div>

        </template>
      </div>
      <p class="btn">
        <v-button @click="exportCSV">Export</v-button>
      </p>
    </div>
    <div class="main">
      <communication-table
        ref="table"
        :marketing-comm="marketing_comm"
        :type="type"></communication-table>
    </div>


  </section>
</template>
<script>
import CommunicationTable from '../communication-table.vue'
import MixinOptions from '@/mixins/options'

export default {
  name: 'NewContainer',
  components:{
    CommunicationTable
  },
  mixins: [MixinOptions],
  data() {
    return {
      activeTab: 'phone',
      tabList: [
        {
          name: 'phone',
          label: 'Phone Numbers',
          type:8
        },
        {
          name: 'email',
          label: 'Emails',
          type:9
        },
        {
          name: 'subscribers',
          label: 'Newsletter Subscribers',
          type:10
        }
      ],
      type: 'phone',
      marketing_comm:1,
      identity:[1,2],
      merchant_platform:'',
      onList:[
        {
          id:1,
          name:'On'
        },
        {
          id:0,
          name:'Off'
        }
      ]
    }
  },
  watch: {
    activeTab:{
      immediate: true,
      handler(v, old){
        if(v != old){
          this.marketing_comm = 1
          this.identity = [1,2]
          this.type = v
        }
      }
    }
  },
  methods:{
    handleChange(){
      this.$refs['table'].getTabaleData({page:1,marketing_comm:this.marketing_comm,identity:this.identity,merchant_platform:this.merchant_platform})
    },
    exportCSV(){
      this.$refs['table'].exportCSV({marketing_comm:this.marketing_comm,identity:this.identit,merchant_platform:this.merchant_platform})
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  .btn{
    text-align: right;
    margin: 5px 0 20px;
    .el-button{
      font-weight: 600;
      font-size: 14px;
      color: #24292E;
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      border-radius: 6px;
    }
  }
  .flex-platform{
    .v-radio-group{
      width: 230px;
    }
    .table-icon__img{
      width: 12px;
      height: 12px;
      margin-right: 4px;
      img{
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>
